const formatNumber = (value) => {
    if (value === null || value === undefined) return "";

    const str = String(value);

    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default formatNumber;
